// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentSlider_container__32L7G","slider":"PaymentSlider_slider__1KabC"};